// 3rd Party
import { Subject } from 'rxjs';
// cc-common imports
import { CCLocalStorageCategory, CCLocalStorageService, Utils } from 'cc-common';
// service imports
import { AuthService } from '../auth.service';
import { ContextManagerService } from '../data-services/context-manager.service';
// constant imports
import { StorageKeyConstants } from '../../_constants/storage-key-constants';
import * as i0 from "@angular/core";
import * as i1 from "../auth.service";
import * as i2 from "../data-services/context-manager.service";
import * as i3 from "cc-common";
export class BookmarkService {
    constructor(authService, contextService, localStorageService) {
        this.authService = authService;
        this.contextService = contextService;
        this.localStorageService = localStorageService;
        this._subjectBookmark = new Subject();
        this._savedBookmarks = [];
        this.authService.getSubjectLoginSuccess().subscribe(() => {
            this.getSavedBookmarkItems();
            this.updateBookmarkSaveNotify();
        });
        this.contextService.getContext().subscribe(() => {
            this.getSavedBookmarkItems();
            this.updateBookmarkSaveNotify();
        });
    }
    getBookmarkSaveNotify() {
        return this._subjectBookmark;
    }
    updateBookmarkSaveNotify() {
        this._subjectBookmark.next(this._savedBookmarks);
    }
    saveBookmarkItems(itemsToStore) {
        itemsToStore = Utils.uniqueList(itemsToStore, 'name');
        this._savedBookmarks = [];
        if (itemsToStore.length > 0) {
            this.localStorageService.setItem(StorageKeyConstants.bookmarks, JSON.stringify(itemsToStore), CCLocalStorageCategory.FAV);
        }
        else {
            this.localStorageService.removeItem(StorageKeyConstants.bookmarks, CCLocalStorageCategory.FAV);
        }
        this.getSavedBookmarkItems();
        this.updateBookmarkSaveNotify();
    }
    getSavedBookmarkItems() {
        const savedBookmarks = JSON.parse(this.localStorageService.getItem(StorageKeyConstants.bookmarks, CCLocalStorageCategory.FAV));
        if (savedBookmarks && savedBookmarks.length > 0) {
            this._savedBookmarks = Utils.uniqueList(savedBookmarks, 'name');
        }
        else {
            this._savedBookmarks = [];
        }
        return this._savedBookmarks;
    }
}
BookmarkService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BookmarkService_Factory() { return new BookmarkService(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.ContextManagerService), i0.ɵɵinject(i3.CCLocalStorageService)); }, token: BookmarkService, providedIn: "root" });
